import React, { MouseEvent, useState, Dispatch, useEffect, useMemo } from 'react';
import { gameVote, fetchGames } from '../../features/player/gameSlice'
import { fetchGameStatus } from '../../features/player/gameStatusSlice'
import { IInjectInfo, IGameStatus } from '../../interfaces';
import { InjectVote } from '../../Classes1';
import VotePercentage from './VotePercentage';
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import _ from 'lodash';

import Modal from 'react-modal';

interface BigInjectProps {
    currentGameStatus: IGameStatus; 
    injectImages: any[];
    finishedInjectImages: any[];
    inject: IInjectInfo;
    intervalHandler: (command: string, gameId: string, inGame: boolean) => void
    iVoted: boolean;
    setIVoted: Dispatch<any>;
    noCoas: boolean;
    index: number;
    setCurrentTurnStatus: Dispatch<string>
}

const customStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0',
      border: 'none',
      width: '640px',
      transform: 'translate(-50%, -50%)',
    }
  };

  Modal.setAppElement('#root');

  const BigInject: React.FC<BigInjectProps> = ({ currentGameStatus, injectImages, finishedInjectImages, inject, intervalHandler, iVoted, setIVoted, noCoas, index, setCurrentTurnStatus }) => {

    const dispatch = useAppDispatch();

    const user = useAppSelector((state) => state.auth.userId)

    const [votingModalIsOpen, setVotingModalIsOpen] = useState<boolean>(false);
    const [rejectedVoteIsOpen, setRejectedVoteIsOpen] = useState<boolean>(false);
    const [voteReason, setVoteReason] = useState<string>('');
    const [voteReasonError, setVoteReasonError] = useState<boolean>(false);
    const [voteCount, setVoteCount] = useState<number>(0);
    const [votePercentage, setVotePercentage] = useState<number>(0);
    const [disableSubmit, setDisableSubmit] = useState<boolean>(false);

    useEffect(() => {

        let votesCount: number = 0;

        for (let i = 0; i<currentGameStatus.moves.length; i++) {
            if (currentGameStatus.moves[i].type === 'inject' && currentGameStatus.moves[i].choice === inject.id.toString() && currentGameStatus.currentTurn === currentGameStatus.moves[i].turn) {
                if (currentGameStatus.moves[i].player === user && currentGameStatus.currentTurnStatus === 'inject') {
                    setIVoted(true)
                }
                votesCount++;
            }
        }

        setVoteCount(votesCount)
        setVotePercentage((votesCount/currentGameStatus.players.length))

    }, [currentGameStatus.moves]) // eslint-disable-line react-hooks/exhaustive-deps

    const openVotingModal = () => {
        setVotingModalIsOpen(true);
    }

    const closeVotingModal = () => {
        setVotingModalIsOpen(false);
    }

    const clickBigVote = async (ev: MouseEvent) => {
        if (noCoas || iVoted) {
            return;
        }

        if (currentGameStatus.activeInjects.length > 1) {
            openVotingModal();
            return;
        }

        let gameVoteObj: any = {};
        gameVoteObj.gameId = currentGameStatus.gameId;
        gameVoteObj.voteObj = {};
        let newVote;

        newVote = new InjectVote();
        newVote.type = 'inject';
        newVote.choice = inject.id.toString();
        newVote.reason = 'Default Chosen';

        gameVoteObj.voteObj = newVote;

        let gameVoteResponse: any = await dispatch(gameVote(gameVoteObj))
        if (gameVoteResponse.error !== undefined) {
            openRejectedVote()
        }

        intervalHandler("start", currentGameStatus.gameId, true)
        await dispatch(fetchGameStatus(currentGameStatus.gameId))
        await dispatch(fetchGames())
        closeVotingModal();
        setVoteReason('')
        setDisableSubmit(false)
    }

    const openRejectedVote = () => {
        setRejectedVoteIsOpen(true);
    }

    const closeRejectedVote = () => {
        setRejectedVoteIsOpen(false);
    }

    const submitVote = async (ev: MouseEvent) => {

        if (disableSubmit) {
            return;
        }

        const target = ev.currentTarget as HTMLTextAreaElement;

        if (target) {

            if (_.isEmpty(voteReason)) {
                // show reason error
                setVoteReasonError(true)
                
            } else {
                setDisableSubmit(true)
                let gameVoteObj: any = {};
                gameVoteObj.gameId = currentGameStatus.gameId;
                gameVoteObj.voteObj = {};
                let newVote;

                newVote = new InjectVote();
                newVote.type = 'inject';
                //newVote.choice = inject.injectId;
                newVote.choice = inject.id.toString();
                //newVote.choice = index.toString();
                newVote.reason = voteReason;

                gameVoteObj.voteObj = newVote;

                const gameVoteResponse: any = await dispatch(gameVote(gameVoteObj));
                if (gameVoteResponse.error !== undefined) {
                    openRejectedVote();
                }

                closeVotingModal();
                setVoteReason('');
                setDisableSubmit(false);
                setCurrentTurnStatus('inject');

                await dispatch(fetchGameStatus(currentGameStatus.gameId));
                await dispatch(fetchGames());
                intervalHandler("start", currentGameStatus.gameId, true);
            }
        }
    }

    const onChangeReason = (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
        const target = ev.currentTarget as HTMLTextAreaElement;

        if (target) {
            setVoteReason(target.value)
        }
    }

    const clickReasonTextarea = (ev: MouseEvent) => {
        ev.stopPropagation();
    }

    let imgUrl = useMemo(() => {
        if (process.env.REACT_APP_IMAGE_SRC === 'local') {
            return _.isEmpty(inject.localImage) ? 'img/big-inject.png' : `data:image/png;base64, ${inject.localImage}`
        }

        const imgRef = (inject.noCoas ? finishedInjectImages : injectImages).find((img) => img.injectId === inject.injectId);
        return (_.isEmpty(imgRef) || _.isEmpty(imgRef.images) || _.isEmpty(imgRef.images.url)) ? 'img/big-inject.png' : imgRef.images.url;
    }, [inject.injectId, inject.localImage, inject.noCoas, finishedInjectImages, injectImages])


    return (
        <div>

            <div className={`big-inject ${iVoted ? 'already-voted' : ''} ${noCoas ? 'no-coas' : ''}`} onClick={clickBigVote}>
                <div style={{backgroundImage: `url(${imgUrl})`}} className="big-inject-image" />
                <div className="big-inject-content">
                    <div className="big-inject-header-title">{inject.name}</div>
                    
                    <div className="big-inject-text">{!_.isEmpty(inject.currentNode) ? inject.currentNode.description : 'no desc'}</div>
                    
                    { !noCoas ? <VotePercentage iVoted={iVoted} voteCount={voteCount} votePercentage={votePercentage} /> : <></> }

                </div>
            </div>

            <Modal
                isOpen={votingModalIsOpen}
                onRequestClose={closeVotingModal}
                style={customStyles}
                shouldCloseOnOverlayClick={true}
                contentLabel="Voting Modal"
            >
                <div className="vote-modal-header">Vote Reasoning <img src="/img/light-grey-x.svg" className="new-modal-padding-close" alt="x" onClick={closeVotingModal}></img></div>

                <div className="vote-modal-text">Please describe your reasoning for selecting the <span className="modal-scenario-name">{inject.name}</span> inject.</div>

                { voteReasonError ? <div className="vote-reason-error">Vote reason required</div> : <></> }
                <textarea className="vote-reason-text" value={voteReason} data-injectid={inject.injectId} onChange={onChangeReason} onClick={clickReasonTextarea}></textarea>

                <button onClick={closeVotingModal} className="new-cancel-btn"><span>Cancel</span></button>
                <button onClick={submitVote} className="new-confirm-btn"><span>Submit</span></button>
            </Modal>

            <Modal
                isOpen={rejectedVoteIsOpen}
                onRequestClose={closeRejectedVote}
                style={customStyles}
                contentLabel="Rejected Vote Modal"
            >
                <div className="game-over-message">You already voted for this inject.</div>
                <button onClick={closeRejectedVote} className="join-game delete-cancel-btn">Close</button>
            </Modal>

        </div>
    )

  }

  export default BigInject